<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-row>
        <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
          <div class="title_page ma-3 mb-0">
            <h4 class="breadcrumb_title_page">รายละเอียดสินค้า</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
      </v-row>
      <section class="mt-10">
        <div class="ma-5">
          <v-card elevation="4" class="pa-3 card_relative">
            <div class="tag_header_profile d-flex">
              <div
                class="grad-dark-brown-arin-bg pa-2 rounded-pill"
                style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25); z-index: 1"
              >
                <div class="logo_timeline mx-auto my-auto">
                  <img src="@/assets/arin_assets/bill_transfer.png" />
                </div>
              </div>
              <v-card elevation="3" class="card_title ml-n5">
                <div class="arin-text-color py-1 pl-8 pr-5">
                  ข้อมูลการโอนสินค้า
                </div>
              </v-card>
            </div>
            <v-row class="pa-4">
              <v-col cols="12" lg="12" md="12" sm="12" xl="12" xs="12">
                <v-row>
                  <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <div class="text_title">
                      วันที่ :
                      <span class="text_detail">
                        {{ transfer.history_created_at }}
                      </span>
                    </div>
                    <br>
                    <div class="text_title">
                      ผู้ดำเนินการ :
                      <span class="text_detail">{{
                        transfer.history_store_name
                      }}</span>
                    </div>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <div class="text_title">
                      สาขาต้นทางที่โอนสินค้า :
                      <span class="text_detail">{{
                        transfer.create_name
                      }}</span>
                    </div>
                    <br>
                    <div class="text_title">
                      สาขาปลายทางที่โอนสินค้า :
                      <span class="text_detail">{{
                        transfer.history_store_name
                      }}</span>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <div class="px-6" style="font-size: 22px">รายการสินค้า</div>
              <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th>ลำดับ</th>
                        <th>รหัสสินค้า</th>
                        <th>รหัสสินค้า</th>
                        <th>ชื่อทางแพทย์</th>
                        <th>จำนวนโอน</th>
                        <th>หน่วยนับ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in transfer_list" :key="index">
                        <td
                          :class="
                            transfer_list.length - 1 == index
                              ? 'table-transfer'
                              : 'hidden_line'
                          "
                        >
                          {{ index+1 }}
                        </td>
                        <td
                          :class="
                            transfer_list.length - 1 == index
                              ? 'table-transfer'
                              : 'hidden_line'
                          "
                        >
                          {{
                            item.product_code == null ? "-" : item.product_code
                          }}
                        </td>
                        <td
                          :class="
                            transfer_list.length - 1 == index
                              ? 'table-transfer'
                              : 'hidden_line'
                          "
                        >
                          {{ item.name == null ? "-" : item.name }}
                        </td>
                        <td
                          :class="
                            transfer_list.length - 1 == index
                              ? 'table-transfer'
                              : 'hidden_line'
                          "
                        >
                          {{ item.name_sci == null ? "-" : item.name_sci }}
                        </td>
                        <td
                          :class="
                            transfer_list.length - 1 == index
                              ? 'table-transfer'
                              : 'hidden_line'
                          "
                        >
                          {{ item.qty == null ? "-" : item.qty }}
                        </td>
                        <td
                          :class="
                            transfer_list.length - 1 == index
                              ? 'table-transfer'
                              : 'hidden_line'
                          "
                        >
                          {{ item.unit_name == null ? "-" : item.unit_name }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-card>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { HTTP_ARIN } from "@/axios_arin";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Detail_customer_point",
  data() {
    return {
      loading_page: false,
      transfer: [],
      transfer_list: [],
      sub_menu: [
        {
          text: "ระบบ POS",
          disabled: false,
        },
        {
          text: "คลังสินค้า",
          disabled: false,
        },
        {
          text: "โอนสินค้า",
          disabled: false,
        },
        {
          text: "รายละเอียดรอบโอนสินค้า",
          disabled: false,
          href: "#",
        },
      ],
    };
  },
  methods: {
    link(link) {
      window.location.href = link;
    },
    getTransfer() {
      this.loading_page = true;
      //   console.log(this.$route.params.id)
      this.product = [];
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get(
        "/warehouse/transferfirst/" + this.$route.params.id,
        config
      ).then((res) => {
        if (res.data.successful === true) {
          this.transfer = res.data.TransferFirst;
          this.transfer_list = res.data.TransferProductList;
          this.loading_page = false;
        }
      });
    },
  },
  mounted() {
    this.getTransfer();
  },
};
</script>

<style scoped>
.card_relative {
  position: relative;
  border-radius: 15px;
}

.profile_detail {
  display: grid;
  grid-template-columns: 30% 70%;
}

.header_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.logo_timeline {
  width: 25px;
  height: 25px;
  padding: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo_timeline > img {
  max-width: 30px;
}

.tag_header_profile {
  position: absolute;
  top: -30px;
  left: -15px;
}

.arin-text-color {
  color: #84611f;
  font-weight: bold;
  font-size: 16px;
}

.arin-text-color-two {
  color: #616a6b;
  font-weight: bold;
  font-size: 16px;
}

.card_title {
  margin-top: 1px;
  margin-bottom: 1px;
  border-radius: 10px;
  border: 1px solid #d6bfaf;
}

.preview {
  border-radius: 10px;
}

.preview.profile_img {
  max-width: 172px;
  border-radius: 30px;
}

.employee_box {
  border-radius: 10px;
  border: 1px solid #d6bfaf;
  width: auto;
}

.sub_title {
  font-size: 16px;
}

.image_title {
  font-weight: 500;
  font-size: 16px;
}

.picture_details {
  display: grid;
  grid-template-columns: 40% 60%;
}

.mobile_btn {
  width: 40%;
}

.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_four_ck {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
}

.text_title {
  color: #909090;
  font-weight: bold;
  font-size: 16px;
}

.text_detail {
  color: #616a6b;
  font-weight: bold;
  font-size: 16px;
}

.btn_detail_data {
  font-size: 16px;
  color: #fff;
  background: linear-gradient(90deg, #0f71b9 0%, rgba(136, 179, 88, 0) 100%),
    #8ebbdc !important;
  border-radius: 10px;
  width: 100%;
}

.table-transfer {
  border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}
</style>
